<template>
  <!--
  -->
  <div class="pb50" v-loading="loading">
    <el-form
      size="small"
      ref="form"
      :model="form"
      label-width="150px"
      v-if="!loading"
    >
      <!--基础设置-->
      <Basic
        :form="form"
        :gradeList="gradeList"
        :app_id="app_id"
        :category="category"
        :is_edit="is_edit"
      ></Basic>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="onSubmit"
        :loading="loading"
        >提交</el-button
      >
    </div>
  </div>
</template>
<script>
import SupplyApi from "@/api/supply.js";
import Basic from "./part/Basic.vue";
import { mergeTable } from "@/utils/table.js";
export default {
  components: {
    /*基础设置*/
    Basic
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*表单对象*/
      form: {
        image_id: 0,
        kmd_grade_id: 0,
        /*名称*/
        name: "",
        /*是否生效，默认1为生效，0为不生效*/
        status: 1,
        // 是否自营
        self_manage: 0,
        user_id: "",
        user_name: "",
        password: "",
        introduce: "",
        remark: "",
        /*默认排序*/
        sort: 100,
        is_forbidden_buy: 0,
        product_show: "two_column",
        notice: "",

        fh_phone: "",
        fh_address: "",
        fh_name: ""
      },
      gradeList: [],
      app_id: 0,
      is_edit: true,
      category: []
    };
  },
  created() {
    /*获取列表*/
    this.form.supply_id = this.$route.query.supply_id;
    this.getData();
    this.getGradeList();
  },
  methods: {
    /*获取数据*/
    getData() {
      const self = this;
      self.loading = true;

      SupplyApi.getSupply(
        {
          supply_id: self.form.supply_id
        },
        true
      )
        .then(function(res) {
          // 使用Vue.set或Object.assign保持响应式
          const detail = res.data.detail;

          // 使用Vue.set逐个设置（确保响应式）
          Object.keys(detail).forEach(key => {
            if (key !== "shop_user") {
              // 排除需要特殊处理的字段
              let value = detail[key];
              // 处理展示图片数据，去除URL前后的空格和反引号
              if (key === "pd_img" && Array.isArray(value)) {
                value = value.map(img => {
                  if (typeof img === 'string') {
                    // 去除字符串前后的空格和反引号
                    const cleanUrl = img.replace(/^[\s`]+|[\s`]+$/g, '');
                    // 转换为与前端上传一致的对象格式
                    return {
                      file_path: cleanUrl,
                      file_id: ''
                    };
                  } else if (typeof img === 'object' && img.file_path) {
                    // 如果是对象格式，也去除file_path中的空格和反引号
                    img.file_path = img.file_path.replace(/^[\s`]+|[\s`]+$/g, '');
                  }
                  return img;
                });
              }
              // 跳过logoImage字段，在后面特殊处理
              if (key !== "logoImage") {
                self.$set(self.form, key, value);
              }
            }
          });

          // 特殊字段处理
          // 使用logoImage作为商家logo的图片路径
          self.$set(self.form, "file_path", detail.logoImage || detail.image_url);
          self.$set(
            self.form,
            "user_name",
            detail.shop_user && detail.shop_user.user_name
              ? detail.shop_user.user_name
              : ""
          );
          self.$set(
            self.form,
            "notice",
            detail.shop_user && detail.shop_user.notice
              ? String(detail.shop_user.notice)
              : ""
          );

          // 处理展示图片数据，使用bannerImages字段
          if (detail.bannerImages && Array.isArray(detail.bannerImages)) {
            const pdImgData = detail.bannerImages.map(url => {
              // 去除URL前后的空格和反引号
              const cleanUrl = url.replace(/^[\s`]+|[\s`]+$/g, '');
              // 转换为与前端上传一致的对象格式
              return {
                file_path: cleanUrl,
                file_id: ''
              };
            });
            self.$set(self.form, "pd_img", pdImgData);
          }

          if (!self.form.product_show) {
            self.$set(self.form, "product_show", "two_column");
          }

          self.loading = false;
        })
        .catch(function(error) {
          self.loading = false;
          console.error("获取数据失败:", error);
        });
    },
    /*获取角色列表*/
    getGradeList() {
      // console.log(444);return
      SupplyApi.gradeLists("", true)
        .then(res => {
          this.gradeList = res.data.list.data;
          this.app_id = res.data.app_id;
          this.category = res.data.category;
        })
        .catch(error => {});
    },

    /*提交表单*/
    onSubmit() {
      let self = this;

 

      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          let params = self.form;
          delete params.tableData;
          SupplyApi.saveSupply(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: "恭喜你，修改成功",
                type: "success"
              });
              self.cancelFunc();
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/supply/supply/edit.vue